import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
// Below is for import the icons
import { TiTick } from "react-icons/ti";
import { ImCross } from "react-icons/im";
import Loading from "../../Student/Reusablecomponents/Loading";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import CopyRight from "../../Student/Reusablecomponents/Copyright";
import ScenarioQuestionformat from "../../Student/Reusablecomponents/ScenarioQuestionformat";
import { AssessmentName } from "../../Student/Reusablecomponents/RegularFunctions";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
// import {
//   Grade,
// } from "../../Student/Reusablecomponents/RegularFunctions";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import NSFLOgo from "../../Student/Assests/Images/NSFLOgo.jpg";
import NCLLOgo from "../../Student/Assests/Images/NCLogo.png";
import { FaAnglesLeft } from "react-icons/fa6";
const QuestionPaper = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const QuestionPaperRef = useRef();
    const items = useSelector((state) => state.userDetailsData.LoginDetails);

    const [ViewSheet, SetViewSheet] = useState({});
    const [GetGrade, SetGetGrade] = useState(props.Grade?.split(",")[0]);
    const [Load, SetLoad] = useState(false);

    // Fetches and displays question paper based on grade and schedule
    const GetQuestionSheet = async () => {
        SetLoad((prev) => !prev);
        
        // If it's an existing QP, use the GetAssessmentQuestionPaper API
        const apiUrl = props.IsExistingQP
            ? process.env.REACT_APP_API_BASE_URL +
              `/NCLAdmin/GetAssessmentQuestionPaper?AssessmentScheduleId=${props.AssessmentScheduleId}&Grade=${GetGrade}`
            : process.env.REACT_APP_API_BASE_URL +
              `/NCLAdmin/GetPreviewQuestionPaper?QuestionIds=${props.QuestionIds}`;
        
        await axios
            .get(apiUrl, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                if (res.data[0].subjectName) {
                    const order = res.data.reduce((acc, item) => {
                        (acc[item.subjectName] = acc[item.subjectName] || []).push(item);
                        return acc;
                    }, {});
                    SetViewSheet(order);
                } else {
                    SetViewSheet({
                        Message: "Please generate questions for selected grade",
                    });
                }
                SetLoad((prev) => !prev);
            })
            .catch((err) => {
                SetViewSheet({
                    Message: "Please generate questions for selected grade",
                });
            });
    };
    useEffect(() => {
        GetQuestionSheet();
    }, [GetGrade])

    // Navigates back to previous page
     const CancelAssessments = () => {
    navigate(-1);
  };

    
// Converts grade string to grade dropdown options
    const Gradeoptions = props.Grade?.split(",").map((item) => ({ display: `Grade ${item}`, value: item }))
    return (
        <>
            <div className="TeacherBgImage ">
                <InternetChecking />
              {/* <div
                    className=" Buttons BackNavigation mb-3 "
                    style={{ float: "left" }}
                    onClick={CancelAssessments}
                >
                    <FaAnglesLeft /> Back{" "}
                </div> */}
                <div className="MainHeading">
                     Question Paper - Grade {props.Grade}
                </div>

                <div className="Deatils-VASheet mt-2" ref={QuestionPaperRef}>
                    {Object?.keys(ViewSheet)?.length > 1 ? (
                        Object.keys(ViewSheet)?.map((order) => (
                            <div key={order} className="QuestionSet">
                                <div className="dflex JSBetween mt-4">
                                    <h5>
                                        <b>Subject :</b> {order}
                                    </h5>
                                    <h6>
                                        <b>Duration :</b> {props.SubjectDetails?.[order]?.duration || 0}mins
                                    </h6>
                                    <h6>
                                        <b>No.of Questions :</b> {props.SubjectDetails?.[order]?.questions || props.NoOfQuestions}
                                    </h6>
                                    <h6>
                                        <b>Total Credits :</b> {(parseInt(props.SubjectDetails?.[order]?.questions || 0) * 2) || props.Credits}
                                    </h6>
                                </div>
                                {ViewSheet[order]?.map((item, index) => (
                                    <div className="Each-Question dflex flexd-column">
                                        {item.scenario && (
                                            <div
                                                className="VScenario dflex flexd-column"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                }}
                                            >
                                                <div>
                                                    {" "}
                                                    <b>Scenario :</b>{" "}
                                                    <ScenarioQuestionformat scenario={item.scenario} />
                                                </div>
                                                <div>
                                                    {" "}
                                                    <b>Scenario Source :</b> {item.sSource} -{" "}
                                                    {item.sBookSource}{" "}
                                                    {item.sComments && (
                                                        <>
                                                            <b>Comments:</b> {item.sComments}
                                                        </>
                                                    )}{" "}
                                                </div>
                                            </div>
                                        )}

                                        <div className="RQuestion dflex">
                                            <div className="Question dflex flexd-column ">
                                                <div>
                                                    <b>Question {index + 1} :</b>
                                                    <ScenarioQuestionformat scenario={item.questions} />
                                                </div>
                                                <div>
                                                    <b>Question Source :</b> {item.qSource} -{" "}
                                                    {item.qBookSource}
                                                </div>
                                            </div>
                                            {/* {location.state?.AType !== 3 && (
                                                <div className="PDFhide">
                                                    <b>School Level Rating :</b> {item.schoolLevelRating}{" "}
                                                    | <b>Overall Rating :</b>
                                                    {item.overall}
                                                </div>
                                            )} */}
                                        </div>
                                        {item.questionType === "M" &&
                                            ["A", "B", "C", "D"].map((option, i) => (
                                                <div
                                                    key={i}
                                                    className="Options"
                                                    style={{
                                                        color:
                                                            option === item.answer
                                                                ? "green"
                                                                : option === item.userAnswer
                                                                    ? "red"
                                                                    : "black",
                                                    }}
                                                >
                                                    {option})
                                                    <span>
                                                        <ScenarioQuestionformat
                                                            scenario={item[`option${option}`]}
                                                        />
                                                        {option === item.answer ? (
                                                            <TiTick fontSize={25} />
                                                        ) : option === item.userAnswer ? (
                                                            <ImCross />
                                                        ) : (
                                                            ""
                                                        )}
                                                    </span>
                                                </div>
                                            ))}

                                        <div className="alignitems">
                                            {" "}
                                            <b>Answer :</b>
                                            <div>
                                                {" "}
                                                <ScenarioQuestionformat scenario={item?.answer} />{" "}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))
                    ) : (
                        <div
                            className="dflex JCCenter"
                            style={{ fontSize: "20px", margin: "2rem 0rem" }}
                        >
                            {" "}
                            {ViewSheet?.Message}
                        </div>
                    )}
                </div>
                <CopyRight />
            </div>

            {Load && <Loading />}
        </>
    );
};
export default QuestionPaper;
